var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('img',{staticClass:"logo1",attrs:{"src":"/maestro/assets/images/police/logo1.svg"}}),_c('img',{staticClass:"logo2",attrs:{"src":"/maestro/assets/images/police/logo2.svg"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }